import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import logo from "../../assets/images/Risoapp_1.png";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 420,
  maxWidth: '90%',
  bgcolor: 'background.paper',
  borderRadius: 4,
  boxShadow: 24,
  fontFamily: "'Kumbh Sans', sans-serif",
  p: 4,
  textAlign: 'center',
  position: 'relative',
};

function Nwsletter({ open, handleClose }) {
  return (
    <Modal
      keepMounted
      open={open}
      onClose={handleClose}
      aria-labelledby="newsletter-modal-title"
    >
      <Box sx={style}>
        {/* Close Button */}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Logo Circle */}
        <Box sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: '#f3f6f9',
          margin: '0 auto',
          mb: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <img src={logo} alt="Riso Logo" style={{ width: '50px' }} />
        </Box>

        {/* Title */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
          You’re Subscribed!
        </Typography>

        {/* Description */}
        <Typography sx={{ color: 'text.secondary', fontSize: '15px' }}>
          Thank you for joining our newsletter.<br />
          You’ll now receive updates, insights & career tips from Riso.
        </Typography>
      </Box>
    </Modal>
  );
}

export default Nwsletter;
